var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.16 4.60828H3.72214C3.56014 4.60828 3.40478 4.67264 3.29023 4.78719C3.17568 4.90174 3.11133 5.0571 3.11133 5.21909C3.11133 5.38109 3.17568 5.53645 3.29023 5.651C3.40478 5.76555 3.56014 5.82991 3.72214 5.82991H4.33295V16.8245C4.33295 17.1485 4.46166 17.4592 4.69076 17.6883C4.91985 17.9174 5.23058 18.0461 5.55457 18.0461H15.3276C15.6515 18.0461 15.9623 17.9174 16.1914 17.6883C16.4205 17.4592 16.5492 17.1485 16.5492 16.8245V5.82991H17.16C17.322 5.82991 17.4773 5.76555 17.5919 5.651C17.7064 5.53645 17.7708 5.38109 17.7708 5.21909C17.7708 5.0571 17.7064 4.90174 17.5919 4.78719C17.4773 4.67264 17.322 4.60828 17.16 4.60828ZM15.3276 16.8245H5.55457V5.82991H15.3276V16.8245ZM6.7762 2.77585C6.7762 2.61385 6.84055 2.45849 6.9551 2.34394C7.06965 2.22939 7.22501 2.16504 7.38701 2.16504H13.4951C13.6571 2.16504 13.8125 2.22939 13.927 2.34394C14.0416 2.45849 14.1059 2.61385 14.1059 2.77585C14.1059 2.93785 14.0416 3.09321 13.927 3.20776C13.8125 3.32231 13.6571 3.38666 13.4951 3.38666H7.38701C7.22501 3.38666 7.06965 3.32231 6.9551 3.20776C6.84055 3.09321 6.7762 2.93785 6.7762 2.77585Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.610811
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.45598c8bf33207daf5027f4679f9e38a.svg";
export { ForwardRef as ReactComponent };